<template>
  <a-checkbox ref="checkboxRef" v-bind="attrs" :class="bem.b()">
    <template
      v-for="item in Object.keys($slots).filter((k) => k !== 'default')"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <span v-if="checkboxLabel">{{ checkboxLabel }}</span>
    <slot v-else> </slot>
  </a-checkbox>
</template>
<script setup lang="ts">
import { ref, useAttrs } from 'vue'
// import { Checkbox } from 'ant-design-vue'
import { createNamespace } from '@ll-plus/utils'
import { checkboxProps } from './checkbox'

defineOptions({ name: 'LlCheckbox' })

defineProps(checkboxProps)

const attrs = useAttrs()

const bem = createNamespace('checkbox')

const checkboxRef = ref()

const blur = () => {
  checkboxRef.value.blur()
}

const focus = () => {
  checkboxRef.value.focus()
}

defineExpose({
  blur,
  focus,
})
</script>
